import {getCode, getGameCodes} from "@/api/utils";
import { RATE_INCREASE } from "@/libs/constants";
import { getDateStr, replceDateT, numberWithCommas, jsonSort,deleteCommas } from "@/libs/utils";

export default {
  data() {
    return {
      userData: {
        memPass: "",
        companyLimit: "0",
        userLimit: "0",
        updId: "",
        domain: "",
        totalCashInAmt: "",
        subMemCnt: "0",
        subCompanyCnt: "0",
        memName: "",
        lastIp: "",
        cashAmt: "0",
        memDelYn: "",
        siteName: "",
        pointAmt: "0",
        totalLoginCount: "",
        recommenderId: "",
        memberCommissionRate: [],
        memStatus: "",
        pointExchangeYn: "",
        maxCredit: "",
        lastLoginDt: "",
        memPhone: "",
        adminId: "",
        totalCashOutAmt: "",
        outAmtYn: "",
        membetType: "",
        retailType: "",
        kplayId: "",
        accInfoRequestYn: "",
        creditStatus: "",
        creditAmt: "0",
        regIp: "",
        totalWlAmt: "",
        redDt: "",
        retailPeriod: "",
        totalBonusAmt: "",
        siteId: "",
        regId: "",
        partnerType: "",
        memLevel: "",
        updDt: "",
        memId: "",
        totalMemCnt: "0"
      },
      memberFlow: [],
      partnerFlow: [],
      redData: {},
      pageInfo: {
        page: 1,
        count_per_list: 30,
        tatal_list_count: 0
      },
      gameListDefault: [],
      rateModel: {
        gameName: "",
        gameType: "",
        groupCode: "",
        pointRate: "0.00",
        maxPointRate: "5.00",
        useYn: true,
        betYn: true
      },
      rateIncrease: RATE_INCREASE
    };
  },
  methods: {
    resetRateToggle(currentRate, originRate, group) {
      if (group === "") {
        currentRate.forEach((target, index) => {
          target.betYn = originRate[index].betYn;
        });
      }else{
        currentRate.forEach((target, index) => {
          if(group===target.groupCode){
            target.betYn = originRate[index].betYn;
          }
        });
      }
    },
    rateAllOn(rateArray, group){
      if (group === "") {
        rateArray.forEach(target => {
          target.betYn = true;
        });
      } else {
        rateArray.forEach(target => {
          if (target.groupCode === group) {
            target.betYn = true;
          }
        });
      }
    },
    rateAllOff(rateArray, group){
      if (group === "") {
        rateArray.forEach(target => {
          target.betYn = false;
        });
      } else {
        rateArray.forEach(target => {
          if (target.groupCode === group) {
            target.betYn = false;
          }
        });
      }
    },
    resetRate(currentRate, originRate, group) {
      if (group === "") {
        currentRate.forEach((target, index) => {
          target.pointRate = originRate[index].pointRate;
        });
      }else{
        currentRate.forEach((target, index) => {
          if(group===target.groupCode){
            target.pointRate = originRate[index].pointRate;
          }
        });
      }
    },
    rateAllMin(rateArray, group) {
      // console.log(group)
      if (group === "") {
        rateArray.forEach(target => {
          target.pointRate = "0.00";
        });
      } else {
        rateArray.forEach(target => {
          if (target.groupCode === group) {
            target.pointRate = "0.00";
          }
        });
      }
    },
    rateAllMax(rateArray, group) {
      // console.log(group)
      if (group === "") {
        rateArray.forEach(target => {
          target.pointRate = target.maxPointRate;
        });
      } else {
        rateArray.forEach(target => {
          if (target.groupCode === group) {
            target.pointRate = target.maxPointRate;
          }
        });
      }
    },
    detailOpen(type, targetId) {
      const name = type + "Detail";
      const routeData = this.$router.resolve({ name: name, query: { id: targetId } });
      window.open(routeData.href, "newpage", "top=0,left=150,scrollbars=no,resizable=no,width=1455,height=825,status=no");
    },
    goToPageName (type, targetId) {
      //this.$router.push(value)
      const name = type + "Detail";
      const routeData = this.$router.resolve({ name: name, query: { id: targetId } });
      // this.$router.push(routeData)
      window.open(routeData.href)
    },
    thousand (value) {
      return value ? thousand(value) : 0
    },
    getDateStr(value) {
      return getDateStr(value);
    },
    numberWithCommas(value) {
      return numberWithCommas(value);
    },
    deleteCommas(value){
      return deleteCommas(value);
    },
    replceDateT(value) {
      return replceDateT(value);
    },
    jsonSort(item, ord, type) {
      return jsonSort(item, ord, type);
    },
    ynToBool(item) {
      let text = item;
      if (item === "Y") {
        text = false;
      } else if (item === "N") {
        text = true;
      } else {
        console.error("item type check: is not YN");
        text = "";
      }
      return text;
    },
    boolToYn(item) {
      let bool = item;
      if (typeof bool !== "boolean") {
        console.error("item type check: is not bool");
        bool = null;
      }
      if (bool) {
        bool = "Y";
      } else {
        bool = "N";
      }

      return bool;
    },
    async setGameList() {
      const deduplicate = arr => {
        arr.filter((item1, idx1) => {
          return (
              arr.findIndex((item2, idx2) => {
                return item1.code === item2.code;
              }) == idx1
          );
        });
      };
      const groups = await getCode("gameGroup");
      const games = await getGameCodes("kplay");
      // // console.log(games)
      const _groups = [];
      if (games.length !== 0) {
        for (const group of groups) {
          // if (group.useYn === "Y") {
            group.child = [];
            for (let i = 0; i < games.length; i++) {
              if (group.code === games[i].groupCode) {
                // if (games[i].useYn === "Y") {
                  group.child.push(games[i]);
                // }
              }
            }
            _groups.push(group);
          // }
        }
      }
      // // console.log(_groups);
      this.$store.commit("setGameList", _groups);
      this.gameListDefault = _groups;
    }
  }
};
